import { DeviceAlert } from "../deviceAlert";

export type RawDevice = {
  readonly code: string;
  readonly countryCode: string;
  readonly currencies: string[];
  readonly delegationCode: string;
  readonly id: string;
  readonly ip: string;
  readonly isMulticlient: boolean;
  readonly manufacturer: string;
  readonly model: string;
  readonly name: string;
  readonly noteCapacity: number;
  readonly port: string;
  readonly solutionType: string;
  readonly type: string;
  readonly lastUpdate: string;
  readonly servicePointCount: number;
  readonly clientMode: string;
  readonly manufacturerNoteCapacity?: number;
  readonly realNoteCapacity?: number;
  readonly prosegurNoteCapacity?: number;
  readonly manufacturerCoinCapacity?: number;
  readonly realCoinCapacity?: number;
  readonly prosegurCoinCapacity?: number;
  readonly deviceAlerts?: DeviceAlert[];
};

export const iniRawDevice: RawDevice = {
  id: "",
  name: "",
  code: "",
  ip: "",
  port: "",
  type: "",
  model: "",
  countryCode: "",
  manufacturer: "",
  solutionType: "",
  delegationCode: "",
  lastUpdate: "",
  clientMode: "",
  currencies: [],
  noteCapacity: 0,
  isMulticlient: false,
  servicePointCount: 0,
};
